import * as XLSX from 'xlsx'
import { notification } from 'antd'
import { Credential } from '../api/credentialsApi'

export const downloadCredentialsAsXLS = (
  credentialsData: Credential[],
  accountId: string
) => {
  try {
    const excelData = credentialsData.map((credential, index) => ({
      '№': index + 1,
      'User ID': credential.userId ?? '',
      Name: credential.name ?? '',
      Login: credential.login ?? '',
      Password: credential.password ?? '',
    }))

    const workbook = XLSX.utils.book_new()
    const worksheet = XLSX.utils.json_to_sheet(excelData)

    XLSX.utils.book_append_sheet(workbook, worksheet, 'Credentials')

    const safeAccountId = accountId
      .replace(/[\\/*?:"<>|]/g, '_')
      .replace(/\s+/g, '_')
      .substring(0, 50)

    const fileName = `credentials_${safeAccountId}_${new Date().toISOString().split('T')[0]}.xlsx`

    XLSX.writeFile(workbook, fileName)
  } catch (error) {
    console.error('❌ Ошибка при создании XLS файла:', error)
    notification.error({
      message: 'Ошибка экспорта',
      description: 'Не удалось создать Excel файл',
    })
  }
}
